import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
  DataStack,
} from '../../../../../../_metronic/helpers'
import {
  useQueryResponse,
  useQueryResponseData,
} from './QueryResponseProvider'
import {
  CustomerSubShow,
  InvoiceSubRow,
  ProductSubShow,
  stuffidFileTagSubRow,
} from '../../../invoice-management/invoices-list/core/_models'

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
  const [variableA, setvariableA] = useState<any>()
  const [variableB, setvariableB] = useState<any>()
  const [variableC, setvariableC] = useState<any>()
  const [variableD, setvariableD] = useState<any>()
  const [nestedOpen, setNestedOpen] = useState<ID[]>([])
  const [shareData, setShareData] = useState<DataStack[]>([])
  const [invoiceNestedRows, setInvoiceNestedRows] = useState<InvoiceSubRow[]>([])
  const [productNestedRows, setProductNestedRows] = useState<ProductSubShow[]>([])
  const [customerNestedRows, setCustomerNestedRows] = useState<CustomerSubShow[]>([])
  const [ebtalNestedRows, setEbtalNestedRows] = useState<CustomerSubShow[]>([])
  const [stuffidFileTagNestedRows, setStuffidFileTagNestedRows] = useState<stuffidFileTagSubRow[]>(
    []
  )
  const {isLoading} = useQueryResponse()
  const data = useQueryResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,
        variableA,
        setvariableA,
        variableB,
        setvariableB,
        variableC,
        setvariableC,
        variableD,
        setvariableD,
        shareData,
        setShareData,
        nestedOpen,
        setNestedOpen,
        invoiceNestedRows,
        setInvoiceNestedRows,
        productNestedRows,
        setProductNestedRows,
        ebtalNestedRows,
        setEbtalNestedRows,
        customerNestedRows,
        setCustomerNestedRows,
        stuffidFileTagNestedRows,
        setStuffidFileTagNestedRows,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
